import { render, staticRenderFns } from "./Inprogress.vue?vue&type=template&id=0a7478ad&"
import script from "./Inprogress.vue?vue&type=script&lang=ts&"
export * from "./Inprogress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports